import {Pipe, PipeTransform} from '@angular/core';
import {UserDto} from '../../Models/User/user.interface';

@Pipe({
  name: 'users',
  standalone: false
})
export class UsersPipe implements PipeTransform {

  transform(items: UserDto[], filter: { id_role?: number }) {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.id_role) {
      items = items.filter((item) => item.id_role == filter.id_role);
    }

    return items;

  }

}
